import { useState } from "react";
import * as yup from 'yup';

const useHandleForm = (submitCallback, invalidDataCallback) => {

  const createInitialData = () => {

    const getInitialFieldData = () => {
      return "";
    }

    const fieldNames = [
      "courseId",
      "name",
    ];

    return fieldNames.reduce((initialData, fieldName) => {
      return ({
        ...initialData,
        [fieldName]: getInitialFieldData(fieldName)
      })
    }, {});
  }

  const [formData, setFormData] = useState(() => createInitialData());

  const dataIsValid = async () => {
    const schema = yup.object().shape({
      courseId: yup.string().required(),
      name: yup.string().required(),
    });

    return await schema.validate(formData, { abortEarly: false })
      .then((castData) => castData)
      .catch(err => {
        if (err instanceof yup.ValidationError) {
          err.inner.forEach(error => {
            console.log(error.message);
          });
          return false;
        }
      });
  }

  const submit = async (extraData = {}) => {
    if (await dataIsValid()) {
      const dataToSend = { ...formData, ...extraData };

      submitCallback(dataToSend);
      return true;
    } else {
      invalidDataCallback();
      return false;
    }
  }

  const setFormValue = (value, fieldName) => {
    setFormData({
      ...formData,
      [fieldName]: value,
    });
  }

  return {
    formData,
    setFormValue,
    submit,
  };
}

export default useHandleForm;